export enum PanelLocationEnum {
    Sidebar = 'sidebar',
    Content = 'content',
}
